import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { RETRY_MODES } from "./config";
import { DefaultRateLimiter } from "./DefaultRateLimiter";
import { StandardRetryStrategy } from "./StandardRetryStrategy";
export var AdaptiveRetryStrategy = /*#__PURE__*/function () {
  function AdaptiveRetryStrategy(maxAttemptsProvider, options) {
    _classCallCheck(this, AdaptiveRetryStrategy);
    this.maxAttemptsProvider = maxAttemptsProvider;
    this.mode = RETRY_MODES.ADAPTIVE;
    var _ref = options !== null && options !== void 0 ? options : {},
      rateLimiter = _ref.rateLimiter;
    this.rateLimiter = rateLimiter !== null && rateLimiter !== void 0 ? rateLimiter : new DefaultRateLimiter();
    this.standardRetryStrategy = new StandardRetryStrategy(maxAttemptsProvider);
  }
  _createClass(AdaptiveRetryStrategy, [{
    key: "acquireInitialRetryToken",
    value: function () {
      var _acquireInitialRetryToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(retryTokenScope) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.rateLimiter.getSendToken();
              case 2:
                return _context.abrupt("return", this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope));
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function acquireInitialRetryToken(_x) {
        return _acquireInitialRetryToken.apply(this, arguments);
      }
      return acquireInitialRetryToken;
    }()
  }, {
    key: "refreshRetryTokenForRetry",
    value: function () {
      var _refreshRetryTokenForRetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(tokenToRenew, errorInfo) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.rateLimiter.updateClientSendingRate(errorInfo);
                return _context2.abrupt("return", this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo));
              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function refreshRetryTokenForRetry(_x2, _x3) {
        return _refreshRetryTokenForRetry.apply(this, arguments);
      }
      return refreshRetryTokenForRetry;
    }()
  }, {
    key: "recordSuccess",
    value: function recordSuccess(token) {
      this.rateLimiter.updateClientSendingRate({});
      this.standardRetryStrategy.recordSuccess(token);
    }
  }]);
  return AdaptiveRetryStrategy;
}();